import { Divider, Grid, Paper } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Button, Input, InputAuto } from "../../controls";
import { Model, UseForm } from "../../hooks";
import { Alert, Form } from "../../layout";
import { Countries } from "../../hooks/Countries";
import { AppContext } from "../../App";
import { API, actions, endpoints } from "../../api/api";
import { RmvEmptyProp, ToFormData } from "../../hooks/Method";
import { useTranslation } from "react-i18next";

const OrgForm = (props) => {
  const { OrgMdl } = Model();
  const { t } = useTranslation();
  const [cities, setCities] = useState([]);
  const { branch, authUser } = useContext(AppContext);
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    resetFormControls,
  } = UseForm(OrgMdl);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    branch.id &&
      API(endpoints.City + actions.GetAllByOrg).getById(
        branch.orgId,
        (res) =>
          res &&
          res.status === 200 &&
          setCities([...res.result.map((j) => ({ ...j, label: j.name }))])
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  useEffect(() => {
    authUser &&
      API(endpoints.Org + actions.GetAuthUserOrg).get(
        (res) =>
          res.status === 200 &&
          setValues((x) => ({ ...x, ...RmvEmptyProp(res.result) }))
      );
    return () => {
      resetFormControls();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);

  const validateForm = () => {
    let temp = {};
    temp.name = values.name !== "" ? "" : t("ValOrgName");
    temp.email = values.email !== "" ? "" : t("ValEmail");
    temp.phone = values.phone !== "" ? "" : t("ValPhone");
    temp.country = values.country !== "" ? "" : t("ValCountry");
    temp.city = values.city !== "" ? "" : t("ValCity");
    temp.state = values.state !== "" ? "" : t("ValState");
    temp.zip = values.zip !== "" ? "" : t("ValZip");
    temp.address = values.address !== "" ? "" : t("ValAddress");

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const onComplete = (res) => {
        if (res && res.status === 200) {
          res.result && setValues((x) => ({ ...x, ...res.result }));
          setAlert({
            isOpen: true,
            type: "success",
            title: t("Success"),
            subTitle: t("OrgSuccessTitle"),
          });
        } else
          setAlert({
            isOpen: true,
            type: "error",
            title: t("Error"),
            subTitle: res.msg,
          });
        setLoading(false);
      };
      API(endpoints.Org + actions.Put).put(
        ToFormData(RmvEmptyProp(values)),
        onComplete
      );
    }
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper>
          <div className="mb-10 d-flex j-between a-center pt-15 pl-15 pr-15">
            <div>
              <h1
                variant="h5"
                className="form-title mb-5 fw-4 gray-color tx-upp
                    border-left"
              >
                {t("EditOrganizationDetails")}
              </h1>
            </div>

            <div>
              <Button type="submit" loading={loading}>
                {t("SaveChanges")}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="pl-15 pr-15 pb-15 mt-30">
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Input
                  label={t("OrganizationName")}
                  name="name"
                  required={true}
                  value={values.name}
                  error={errors.name}
                  onChange={handleInpChg}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Input
                  label={t("LocaleOrgName")}
                  name="nameLocale"
                  value={values.nameLocale}
                  error={errors.nameLocale}
                  onChange={handleInpChg}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Input
                  label={t("Email")}
                  name="email"
                  required={true}
                  value={values.email}
                  error={errors.email}
                  onChange={handleInpChg}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Input
                  label={t("Phone")}
                  name="phone"
                  required={true}
                  value={values.phone}
                  error={errors.phone}
                  onChange={handleInpChg}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <InputAuto
                  label={t("Country")}
                  name="country"
                  required={true}
                  value={values.country}
                  error={errors.country}
                  onChange={handleInpChg}
                  options={Countries}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <InputAuto
                  label={t("City")}
                  name="cityId"
                  required={true}
                  value={values.cityId}
                  error={errors.cityId}
                  onChange={handleInpChg}
                  options={cities}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Input
                  label={t("State")}
                  name="state"
                  required={true}
                  value={values.state}
                  error={errors.state}
                  onChange={handleInpChg}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Input
                  label={t("ZIP")}
                  name="zip"
                  required={true}
                  value={values.zip}
                  error={errors.zip}
                  onChange={handleInpChg}
                />
              </Grid>
              <Grid item xs={12}>
                <Input
                  label={t("Address")}
                  name="address"
                  required={true}
                  value={values.address}
                  error={errors.address}
                  onChange={handleInpChg}
                />
              </Grid>
            </Grid>
          </div>
        </Paper>
      </Form>
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default OrgForm;
